<template>
  <div class="errorMessageContent">
    <img src="@/assets/注意マーク（小）.png" />{{ msg }}
  </div>
</template>

<script>
export default {
  name: 'ErrorMessage',
  props: {
    msg: String
  }
}
</script>

<style scoped lang="scss">
.errorMessageContent {
  color: rgb(198, 25, 6);
  font-weight: bold;
}
</style>
